import React from 'react';

import ChromeTabs from '../../components/ui/ChromeTabs.jsx';
import TicketData from '../../components/ui/TicketData.jsx';

function ShowTickets() {
  return (
    <>
      <TicketData />
      <ChromeTabs />
    </>
  );
}

export default ShowTickets;
